import React from 'react';

import ProjectAvatar from 'components/ProjectAvatar';
import ProjectName from 'components/project-name';
import ProjectNav from 'components/project-nav';
import AppSidebarExpand from 'components/app-sidebar-expand';
import ProjectUsersList from 'components/project-users-list';
import ProjectCustomFields from 'components/project-custom-fields';
import ProjectUtils from 'components/project-utils';
import AutomationToggle from 'components/AutomationToggle';
import CanUser from 'components/can-user';
import FeatureAvailable from 'components/feature-available';

const ProjectHeader = ({ projectId, currentNavItem, withActions = true, withNav = true, withAutomation = true, children }) => {
    return (
        <div className="header">
            <div className={'header-main' + (withNav ? ' with-nav' : '')}>
                <AppSidebarExpand />

                <ProjectAvatar id={projectId} withEdit={true} />

                <div className="header-main-inner">
                    <div className="header-title">
                        <h1><ProjectName id={projectId} /></h1>

                        {
                            withActions ? (
                                <React.Fragment>
                                    <div className="header-title-meta">
                                        <ProjectUtils id={projectId} />
                                    </div>

                                    {
                                        withAutomation ? (
                                            <FeatureAvailable type="automationsVisible">
                                                <CanUser type="projectAutomations">
                                                    <AutomationToggle projectId={projectId} />
                                                </CanUser>
                                            </FeatureAvailable>
                                        ) : null
                                    }

                                    <div className="header-title-meta">
                                        <ProjectUsersList projectId={projectId} />
                                    </div>

                                    <div className="header-title-meta">
                                        <ProjectCustomFields id={projectId} />
                                    </div>
                                </React.Fragment>
                            ) : null
                        }
                    </div>

                    {
                        withNav ? (
                            <div className="header-meta">
                                <ProjectNav current={currentNavItem} projectId={projectId} />
                            </div>
                        ) : null
                    }
                </div>
            </div>

            {
                children ? (
                    <div className="header-right">
                        <div className="header-utils-holder">
                            <div className="header-utils">
                                { children }
                            </div>
                        </div>
                    </div>
                ) : null
            }
        </div>
    )
}

export default ProjectHeader;
